export enum ModalType {
  ItemCard,
  SalesVelocity
}
